import { render } from "./AppAdmin.vue?vue&type=template&id=bc2af72e&scoped=true"
import script from "./AppAdmin.vue?vue&type=script&lang=js"
export * from "./AppAdmin.vue?vue&type=script&lang=js"

import "./AppAdmin.vue?vue&type=style&index=0&id=bc2af72e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc2af72e"]])

export default __exports__